module.exports = __webpack_public_path__ + "static/magic-63a670ad12070e45b18522f158368013.mp3";